import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTabs } from "../../../../../components";
import ComissionDataHybrid from "../ComissionDataHybrid";
import { BetRebate, DepositRebate } from "./components";
import styles from "./style.module.scss";

const ComissionBetAmountRebate = ({ hybrid = false }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("bet_rebate");

  const tabItems = [
    {
      key: "bet_rebate",
      title: t("normal.betRebate"),
      component: <BetRebate />,
      destroyOnClose: false,
    },
    {
      key: "deposit_rebate",
      title: t("normal.depositRebate"),
      component: <DepositRebate />,
      destroyOnClose: false,
    },
    {
      key: "comission_data",
      title: t("mobile.comission.data"),
      component: <ComissionDataHybrid />,
      destroyOnClose: true,
      hidden: hybrid === false,
    },
  ];

  const onTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <div className={`${styles.container}`}>
      <CustomTabs
        activeKey={activeTab}
        onTabChange={onTabChange}
        tabItems={tabItems.filter((item) => !item.hidden)}
      />
    </div>
  );
};

export default ComissionBetAmountRebate;
